import { makeIconDef } from "./makeIconDef";
import React from "react";

export const ContrastIconDef = {
  contrast: makeIconDef('contrast', {
    regular: () => <path fillRule="evenodd" clipRule="evenodd" d="M20 12C20 16.4183 16.4183 20 12 20V12V4C16.4183 4 20 7.58172 20 12ZM12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 9.52698 3.99744 7.28693 5.61198 5.66019C5.61998 5.65213 5.628 5.64408 5.63604 5.63604C5.64408 5.628 5.65213 5.61998 5.66019 5.61198C7.28693 3.99744 9.52698 3 12 3Z" fill="currentColor" />,
  })
}